<template>
  <div class="mainContent">
    <img :src="image" />
  </div>
</template>

<script>
const image = require('@/assets/image/info/franchise.jpg');

export default {
  name: 'root-franchise',
  data() {
    return {
      image,
    };
  },
};
</script>

<style scoped lang="scss">
.mainContent {
  img {
    width: 100%;
  }
}
</style>
